import React, { useState, useEffect } from 'react'
import style from './CustomAlert.module.scss'
import { Btn } from '../../c_ui/Btn'

export const CustomAlert = ({ message, onClose, onAgree }) => {
	const [isClosing, setIsClosing] = useState(false)

	const handleClose = () => {
		setIsClosing(true)
		setTimeout(() => {
			onClose()
		}, 300) // Час має співпадати з CSS-анімацією
	}

	// Якщо тобі потрібна авто-зачистка після onAgree
	const handleAgree = () => {
		setIsClosing(true)
		setTimeout(() => {
			if (onAgree) onAgree()
		}, 300)
	}

	return (
		<div className={style.backdrop}>
			<div className={`${style.container} ${isClosing ? style.fadeOut : ''}`}>
				<p className={style.message}>{message}</p>

				{onAgree ? (
					<>
						<Btn text={'ТАК'} handle={handleAgree} />
						<Btn text={'НІТ'} handle={handleClose} />
					</>
				) : (
					<Btn text={'OK'} handle={handleClose} />
				)}
			</div>
		</div>
	)
}
